export const victimStatuses = ['approved', 'waiting', 'rejected'];
export const sexes = ['male', 'female'];
export const iconColors = {
    red: '#FF0000',
    blue: '#77B7F7',
    white: '#FFFFFF',
};
export const locales = ['ua', 'en'];
